/**
 * CalendarItem
 * @module components/CalendarItem
 */
import PropTypes from 'prop-types';
import {
	Link,
	Text,
	CalendarItemStyle,
	DateStyle,
	DateHeader,
	DateContent,
	CalendarEventStyle,
} from './PressCalendariumBlock.styles';
import { useSiteType } from 'context/siteType.context';

const CalendarItem = ({ day, month, date, name, link }) => {
	const siteType = useSiteType();
	return (
		<CalendarItemStyle>
			<DateStyle>
				<DateHeader>{month}</DateHeader>
				<DateContent>{day}</DateContent>
			</DateStyle>
			<CalendarEventStyle>
				<Text isLindGroup={siteType === 'LindabGroup'}>{date}</Text>
				<Link isLindGroup={siteType === 'LindabGroup'} href={link}>
					{name}
				</Link>
			</CalendarEventStyle>
		</CalendarItemStyle>
	);
};
CalendarItem.propTypes = {
	day: PropTypes.string,
	month: PropTypes.string,
	date: PropTypes.string,
	name: PropTypes.string,
};

export default CalendarItem;
